module.exports = __webpack_public_path__ + "static/media/heritage.595b174b.png";